import { DetailsDrawerReducerState } from './types';

export const initialState: DetailsDrawerReducerState = {
  type: null,
};
